exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".verMas[data-v-048771a0]{position:absolute;bottom:2%;left:7%}.iconosHoteles[data-v-048771a0]{font-size:15px!important}.img-fluid[data-v-048771a0]{border-radius:25px}.hotelItem[data-v-048771a0]{border-radius:25px;border:2px solid #0b773d;height:450px;position:relative}.bannerFont[data-v-048771a0]{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-048771a0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home/Hoteles.vue
// module id = 474
// module chunks = 2